import { checkErrorExist, convertError } from './converters';
import { getTimeZone } from 'react-native-localize';
import { isObject } from '../utils/util_helpers';
import { updateGlobalData } from './api_user';
import { handleFirstResponse } from '../utils/util_api_response';
import { apiWrapper } from './helpers';

import { getGlobalState, setGlobalState, STATE_KEYS } from '../configs/config_state';

import GLOBAL from '../configs/config_global';
import { cloneDeep } from 'lodash';

// region GET - All Cuisines
export function getCuisineList() {
    return apiWrapper(
        '/cuisine',
        'GET',
        'GET CUISINE LIST'
    );
}
// endregion

// region Get Truck Detail Data
export function getTruckDetail(truckID) {
    return apiWrapper(
        '/vendor/v1/foodtrucks/' + truckID,
        'GET',
        'GET TRUCK DETAIL'
    );
}
// endregion

// region Get Truck Detail Data
export function getTruckDetailConsumer(truckID) {
    return apiWrapper(
        '/consumer/v1/foodtrucks/' + truckID,
        'GET',
        'GET TRUCK DETAIL (CONSUMER API)'
    );
}
// endregion

// region Get Truck Calendar
export function getFoodTruckCalendar(truckID) {
    return new Promise((resolve, reject) => {
        apiWrapper(`/consumer/v1/foodtrucks` + (isNaN(truckID) ? '/slug/' : '/') + truckID + `/calendar?page=1`, 'GET', 'GET TRUCK CALENDAR')
            .then((firstResult) => {
                let lastPage = firstResult['lastPage'];

                if (lastPage === 1) {
                    resolve(firstResult);
                    return;
                }

                let apiCalls = [],
                    fullArr = firstResult.data;

                if (lastPage > 1) {
                    for (let i = 2; i <= lastPage; ++i) {
                        apiCalls.push(apiWrapper(
                            `/consumer/v1/foodtrucks` + (isNaN(truckID) ? '/slug/' : '/') + truckID + `/calendar?page=${i}`,
                            'GET',
                            'GET TRUCK CALENDAR'
                        ));
                    }

                    Promise.all(apiCalls)
                        .then((resultArr) => {
                            resultArr.forEach((smallResult) => fullArr = fullArr.concat(smallResult.data));
                            console.log('[SUCCESS - FULL ARR] GET TRUCK CALENDAR', fullArr);
                            resolve({ data: fullArr });
                        })
                        .catch((allError) => {
                            console.log('[FAILED - PROMISE ALL] GET TRUCK CALENDAR', allError);
                            resolve(firstResult);
                        });
                }
                else resolve(firstResult);
            })
            .catch((firstError) => reject(firstError));
    });
}
// endregion

// region List Vendor Truck
export function getTruckListVendor(keyword = '', currentPage = 1, pageSize = 20) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/account/trucks?keyword=${keyword}&page=${currentPage}&per_page=${pageSize}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] GET TRUCK LIST VENDOR', response);
                    resolve({
                        data: response.data,
                        currentPage: response['current_page'],
                        lastPage: response['last_page'],
                        totalResult: response['total']
                    });
                }
                else {
                    console.log('[FAILED] GET TRUCK LIST VENDOR', response);
                    reject(convertError(response['errors']));
                }
            })
            .catch((error) => {
                console.log('[FAILED] GET TRUCK LIST VENDOR', error);
                reject(error.message);
            });
    });
}
// endregion

// region Get Truck Location List
export function getLocationList() {
    return new Promise((resolve) => {
        fetch(GLOBAL.FATHER_LINK + '/vendor/v1/account/locations', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] GET LOCATION LIST', response);
                    resolve(response.locations);
                }
                else resolve([]);
            })
            .catch(() => resolve([]));
    });
}
// endregion

// region Update Truck Profile
export function updateTruckProfile(truckID, truckProfileObj) {
    const data = new FormData();
    data.append('_method', 'PATCH');
    Object.keys(truckProfileObj).forEach((key) => (key !== 'licenseNumberArr') && data.append(key, truckProfileObj[key]));
    const licenseArr = truckProfileObj['licenseNumberArr'] || [];
    licenseArr.forEach((item, index) => {
        data.append(`license_numbers[${index}][city_id]`, item.id);
        data.append(`license_numbers[${index}][license_number]`, item.value);
    });

    console.log('[INFO] UPDATE TRUCK PROFILE', truckProfileObj);

    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: data,
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] UPDATE TRUCK PROFILE', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] UPDATE TRUCK PROFILE', response.errors);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] UPDATE TRUCK PROFILE', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Update Truck Name
export function updateTruckName(truckID, newName) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({ name: newName }),
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] UPDATE TRUCK NAME', response);
                    let newTruckData = Object.assign({}, GLOBAL.DATA.USER.trucks[0], { name: newName }),
                        newUserData = Object.assign({}, GLOBAL.DATA.USER, { trucks: [newTruckData] });

                    updateGlobalData(GLOBAL.DATA.USER_TOKEN, newUserData, newUserData['has_password'] ? 'email' : 'square');
                    resolve(newTruckData);
                }
                else {
                    console.log('[FAILED] UPDATE TRUCK NAME', response.errors);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] UPDATE TRUCK NAME', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Enable Mobile Ordering
export function enableMobileOrdering(truckID) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/mobile-order`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            }
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] ENABLE MOBILE ORDERING', response);

                    let newTruckData = Object.assign(getGlobalState(STATE_KEYS.TRUCK_DATA), response);

                    // Update to global data
                    GLOBAL.DATA.USER = Object.assign(GLOBAL.DATA.USER, { trucks: [newTruckData] });

                    // Set to main state data
                    setGlobalState(STATE_KEYS.TRUCK_DATA, newTruckData);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] ENABLE MOBILE ORDERING', response.errors);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] ENABLE MOBILE ORDERING', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Update Truck Logo
export function updateTruckLogo(truckID, newLogo) {
    let data = new FormData();
    data.append('logo', newLogo, 'newLogo');
    data.append('_method', 'PATCH');

    console.log('DATA SENDING', Object.fromEntries(data));

    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/logo`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: data,
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] UPDATE TRUCK LOGO', response);

                    const newTruckData = Object.assign(getGlobalState(STATE_KEYS.TRUCK_DATA), response);

                    // Update to global data
                    GLOBAL.DATA.USER = Object.assign(GLOBAL.DATA.USER, { trucks: [newTruckData] });

                    // Set to main state data
                    resolve(newTruckData);
                }
                else {
                    console.log('[FAILED] UPDATE TRUCK LOGO', response.errors);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] UPDATE TRUCK LOGO', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Update Truck Cover
export function updateTruckCover(truckID, newCover) {
    let data = new FormData();
    data.append('photos[0]', newCover, 'newCover');

    console.log('DATA SENDING', Object.fromEntries(data));

    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/cover-photos`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: data,
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] UPDATE TRUCK COVER', response);

                    const newTruckData = Object.assign(cloneDeep(getGlobalState(STATE_KEYS.TRUCK_DATA)), { cover_photos: response['cover_photos'] });

                    // Update to global data
                    GLOBAL.DATA.USER = Object.assign(GLOBAL.DATA.USER, { trucks: [newTruckData] });

                    // Set to main state data
                    resolve(response['cover_photos']?.pop());
                }
                else {
                    console.log('[FAILED] UPDATE TRUCK COVER', response.errors);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] UPDATE TRUCK COVER', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Import Google Calendar
export function importGoogleCalendar(startDate, endDate, calendarID) {
    let dataObj = {
        'start_date': startDate,
        'end_date': endDate,
        'calendar_id': calendarID,
        'timezone': getTimeZone()
    };

    console.log(dataObj);

    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/events/import`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify(dataObj),
            timeout: 10000
        })
            .then((response) => handleFirstResponse(response))
            .then((response) => {
                if (!response.hasOwnProperty('errors') && !response.exception) {
                    console.log('[SUCCESS] FETCH CALENDAR LIST', response);
                    resolve(response.original);
                }
                else {
                    console.log('[FAILED] FETCH CALENDAR LIST', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] FETCH CALENDAR LIST', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Export Single Calendar Event
export function exportSingleCalendarEvent(eventItem, locationID = null) {
    return new Promise((resolve, reject) => {
        let link = GLOBAL.FATHER_LINK + '/vendor/v1/events/export';
        fetch(link, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify(Object.assign({}, eventItem, locationID ? { squareup_location_id: locationID } : {})),
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (isObject(response) && !response.hasOwnProperty('errors') && !response.exception) {
                    console.log('[SUCCESS] EXPORT CALENDAR ITEM', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] EXPORT CALENDAR ITEM', response);
                    reject(convertError(response.errors || response));
                }
            })
            .catch((error) => {
                console.log('[FAILED] EXPORT CALENDAR ITEM', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Export Single Calendar Event
export function exportAllCalendarEvents(eventList) {
    return new Promise((resolve, reject) => {
        let link = GLOBAL.FATHER_LINK + '/vendor/v1/events/export_all';
        fetch(link, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify(eventList),
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (Array.isArray(response)) {
                    console.log('[SUCCESS] EXPORT ALL EVENTS', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] EXPORT ALL EVENTS', response);
                    reject(convertError(response.errors || response));
                }
            })
            .catch((error) => {
                console.log('[FAILED] EXPORT ALL EVENTS', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Edit Existing Event
export function editEvent(eventItem, locationID = null) {
    return new Promise((resolve, reject) => {
        let link = GLOBAL.FATHER_LINK + '/vendor/v1/events/' + eventItem.id,
            sendObj = JSON.stringify(Object.assign({}, eventItem, { squareup_location_id: locationID ? locationID.trim() : null }));

        fetch(link, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: sendObj,
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors') && !response.exception) {
                    console.log('[SUCCESS] UPDATE CALENDAR ITEM', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] UPDATE CALENDAR ITEM', response);
                    reject(convertError(response.errors || response));
                }
            })
            .catch((error) => {
                console.log('[FAILED] UPDATE CALENDAR ITEM', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Authorize new Google Email
export function authGoogleEmail(authCode) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/events/auth`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({
                server_auth_code: authCode,
                source: 'web'
            }),
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors') && !response.exception) {
                    console.log('[SUCCESS] AUTH NEW GOOGLE EMAIL', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] AUTH NEW GOOGLE EMAIL', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] AUTH NEW GOOGLE EMAIL', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Get Calendar ID List from Google Calendar
export function getCalendarList() {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/events/calendars`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors') && !response.exception) {
                    console.log('[SUCCESS] FETCH CALENDAR IDS', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] FETCH CALENDAR IDS', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] FETCH CALENDAR IDS', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Delete Event from Calendar
export function deleteCalendarEvent(eventID, date = '', type = 3) {
    return new Promise((resolve, reject) => {
        let link = GLOBAL.FATHER_LINK + '/vendor/v1/events/' + eventID;
        fetch(link, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({ type, date }),
            timeout: 10000
        })
            .then((response) => handleFirstResponse(response))
            .then((response) => {
                if (!response.hasOwnProperty('errors') && !response.exception) {
                    console.log('[SUCCESS] DELETE CALENDAR ITEM', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] DELETE CALENDAR ITEM', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] DELETE CALENDAR ITEM', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Get Truck List
export function getAlbumPhotos(truckID, albumID, currentPage = 1, pageSize = 10) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/consumer/v1/foodtrucks/${truckID}/album/${albumID}?page= ${currentPage}&per_page=${pageSize}`
            , {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 10000
            })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] GET ALBUM PHOTOS', response);
                    resolve({
                        data: response.data,
                        currentPage: response['current_page'],
                        lastPage: response['last_page'],
                        totalResult: response['total']
                    });
                }
                else {
                    console.log('[FAILED] GET ALBUM PHOTOS', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[SUCCESS] GET ALBUM PHOTOS', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Get Last Photo Position
export function getLastPhotoPosition(truckID, albumID) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/album-item/${albumID}/max-position`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
                }
            })
            .then((response) => response.json())
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] GET LAST PHOTO POSITION', response);
                    resolve(Number(response?.max || 0));
                }
                else {
                    console.log('[FAILED] GET LAST PHOTO POSITION', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[SUCCESS] GET LAST PHOTO POSITION', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Add Truck Photo (Multi)
export function addTruckPhotoMulti(truckID, albumID, startingPosition, imageList, onProgress = () => {}) {
    let data = new FormData();
    imageList.forEach((item, index) => {
        data.append(`photos[${index}][photo]`, item);
        data.append(`photos[${index}][position]`, (startingPosition + index).toString());
    });

    console.log('[MULTI PHOTO] SENDING DATA', data);

    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/album-item/${albumID}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: data,
            onProgress: (e) => onProgress(Number((e.loaded / e.total * 100).toFixed(2)))
        })
            .then((response) => handleFirstResponse(response?.response || {}))
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] ADD TRUCK PHOTO (MULTI)', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] ADD TRUCK PHOTO (MULTI)', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] ADD TRUCK PHOTO (MULTI)', error.message);
                reject(error.message);
            });
    });
}
// endregion

// region Delete Truck Photo (Multi)
export function deleteMultiTruckPhoto(truckID, albumID, imageIDList) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/album-item/${albumID}/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN,
                '_method': 'DELETE'
            },
            body: JSON.stringify({
                'photos': imageIDList.map((itemID) => ({ 'photo_id': itemID }))
            })
        })
            .then((response) => {
                if (response.status !== 204) {
                    response.json()
                        .then((response) => {
                            console.log('[FAILED] DELETE MULTI TRUCK PHOTO', response.errors);
                            if (isObject(response)) {
                                reject(convertError(response.errors));
                            }
                            else reject(response);
                        })
                        .catch((error) => {
                            console.log('[FAILED] DELETE MULTI TRUCK PHOTO', error.message);
                            reject(error.message);
                        });
                }
                else resolve(true);
            });
    });
}
// endregion

// region Switch Auto Sync
export function switchAutoSync(truckID, customCalendar = null, squareLocation = '') {
    return new Promise((resolve, reject) => {
        const link = GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/sync-calendar`;
        fetch(link, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify(
                Object.assign(
                    customCalendar ? { sync_calendar_email: customCalendar.email, sync_calendar_name: customCalendar.name } : {},
                    squareLocation ? { sync_square_location: squareLocation } : {}
                )
            )
        })
            .then((response) => {
                if (response.status === 200) {
                    GLOBAL.DATA.USER['is_sync_calendar'] = (GLOBAL.DATA.USER['is_sync_calendar'] === 1 ? 0 : 1);
                    GLOBAL.DATA.USER['sync_calendar_email'] = customCalendar?.email;
                    GLOBAL.DATA.USER['sync_calendar_name'] = customCalendar?.name;
                    console.log('[SUCCESS] SWITCH AUTO SYNC', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] SWITCH AUTO SYNC', response);
                    reject(convertError(response['errors']));
                }
            })
            .catch((error) => {
                console.log('[FAILED] SWITCH AUTO SYNC', error);
                reject(error.message);
            });
    });
}
// endregion

// region Switch Auto Sync
export function setDefaultSyncSquareLocation(squareLocationID) {
    return new Promise((resolve, reject) => {
        const link = GLOBAL.FATHER_LINK + `/vendor/v1/account/locations/${squareLocationID}/default`;
        fetch(link, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            }
        })
            .then((response) => {
                if (response.status === 200) {
                    GLOBAL.DATA.USER['sync_square_location'] = squareLocationID;
                    let oldIndex = GLOBAL.DATA.USER['locations'].findIndex((squareItem) => squareItem['is_default'] === 1),
                        newIndex = GLOBAL.DATA.USER['locations'].findIndex((squareItem) => squareItem['squareup_location_id'] === squareLocationID);

                    if (oldIndex > -1) GLOBAL.DATA.USER['locations'][oldIndex]['is_default'] = 0;
                    GLOBAL.DATA.USER['locations'][newIndex]['is_default'] = 1;

                    console.log('[SUCCESS] SET DEFAULT SYNC SQUARE LOCATION', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] SET DEFAULT SYNC SQUARE LOCATION', response);
                    reject(convertError(response['errors']));
                }
            })
            .catch((error) => {
                console.log('[FAILED] SET DEFAULT SYNC SQUARE LOCATION', error);
                reject(error.message);
            });
    });
}
// endregion

// region Set Close Date
export function setCloseDate(truckID, returnDate, statusID = 1) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/status`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({
                return_date: returnDate,
                status: statusID
            })
        })
            .then((response) => {
                console.log(response.status);
                return(response.json());
            })
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] SET OFF-WORK REASON', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] SET OFF-WORK REASON', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] SET OFF-WORK REASON', error);
                reject(error.message);
            });
    });
}
// endregion

// region Remove Google Account
export function removeGoogleAccount() {
    return new Promise((resolve, reject) => {
        const link = GLOBAL.FATHER_LINK + `/vendor/v1/events/rm-auth`;
        fetch(link, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            }
        })
            .then((response) => {
                console.log(response.status);
                return response.json();
            })
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    if (GLOBAL.DATA.USER) {
                        GLOBAL.DATA.USER['is_sync_calendar'] = 0;
                        GLOBAL.DATA.USER['google_email'] = '';
                        GLOBAL.DATA.USER['google_access_token'] = '';
                    }

                    console.log('[SUCCESS] REMOVE GOOGLE ACCOUNT', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] REMOVE GOOGLE ACCOUNT', response);
                    reject(convertError(response['errors']));
                }
            })
            .catch((error) => {
                console.log('[FAILED] REMOVE GOOGLE ACCOUNT', error);
                reject(error.message);
            });
    });
}
// endregion

// region Update Photo Order
export function updatePhotoOrder(truckID, albumID, sortArr = []) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/album-item/${albumID}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({ photos: sortArr }),
            timeout: 10000
        })
            .then((response) => response.status === 204 ? {} : response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    resolve(response);
                    console.log('[SUCCESS] UPDATE PHOTO ORDER', response);
                }
                else {
                    reject(convertError(response.errors));
                    console.log('[FAILED] UPDATE PHOTO ORDER', response);
                }
            })
            .catch((error) => {
                console.log('[FAILED] UPDATE PHOTO ORDER', error.message);
                reject(error.message);
            });
    });
}
// endregion

// POST - Pull locations from Square
export function pullLocationsFromSquare() {
    return apiWrapper(
        '/vendor/v1/account/locations',
        'POST',
        'PULL LOCATIONS FROM SQUARE'
    );
}
// endregion

// region POST - Save Temp Truck Profile
export function saveTempTruckProfile({ email, phone, contact_name, name }) {
    return apiWrapper(
        '/vendor/v1/account/profile-tracking',
        'POST',
        'SAVE TEMP VENDOR PROFILE',
        JSON.stringify({ email, phone, contact_name, name }),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion

// region GET - Catering Sample Files
export function getCateringMenuSampleFiles(truckID, albumID) {
    return apiWrapper(
        GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/album-item/${albumID}`,
        'GET',
        'GET CATERING MENU SAMPLE FILES',
        null,
        (result) => setGlobalState(STATE_KEYS.CATERING_MENU_SAMPLES, result?.data || [])
    );
}
// endregion

// region POST - Upload Catering Sample File
export function uploadCateringMenuSampleFile(truckID, albumID, newFile) {
    return new Promise((resolve, reject) => {
        apiWrapper(
            GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/album-item/${albumID}/max-position`,
            'GET',
            'LAST CATERING MENU SAMPLE POSITION'
        )
            .then((response) => {
                const lastPos = Number(response?.max || 0);
                const data = new FormData();
                data.append(`photos[0][photo]`, newFile);
                data.append(`photos[0][position]`, (lastPos + 1).toString());
                data.append(`photos[0][name]`, newFile.name);

                console.log('[SAMPLE CATERING FILE UPLOAD] SENDING DATA', data);

                // Start uploading
                apiWrapper(
                    GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/album-item/${albumID}`,
                    'POST',
                    'UPLOAD CATERING SAMPLE FILE',
                    data,
                ).then((uploadResult) => resolve(uploadResult)).catch((uploadError) => reject(uploadError));
            })
            .catch((error) => reject(error));
    });
}
// endregion

// region DELETE - Delete Catering Sample File
export function deleteCateringMenuSampleFile(truckID, albumID, fileID) {
    return apiWrapper(
        GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/album-item/${albumID}/delete`,
        'POST',
        'DELETE CATERING SAMPLE FILE',
        JSON.stringify({ 'photos': [{ 'photo_id': fileID }] }),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion
